<ng-container [formGroup]="formGroupPresetOption">
    <div class="row">
        <div class="col-12">
            <app-mdb-switch label="Allow donor to select Deity" formControlName="deityRequired"></app-mdb-switch>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill">
                <mdb-select formControlName="recurrence" class="mdb-select">
                  <mdb-option *ngFor="let frequency of frequencies"  [value]="frequency.value">{{
                    frequency.label
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Puja frequency</label>
                <mdb-error class="form-fill-error"  *ngIf="formGroupPresetOption.controls.recurrence.hasError('required') && formGroupPresetOption.controls.recurrence.touched">Please provide Frequency</mdb-error>
            </mdb-form-control>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 0">
                <div class="row justify-content-left">
                    <div class="col-12">
                        <mdb-form-control class="form-fill">
                            <mdb-select formControlName="optionDay" class="mdb-select">
                              <mdb-option *ngFor="let optionDay of optionDayList"  [value]="optionDay.value">{{
                                optionDay.label
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Day Option</label>
                        </mdb-form-control>
                    </div>
                    <div class="col-12" *ngIf="formGroupPresetOption.value.optionDay === 1">
                        <app-datepicker formControlName="pujaDate" label="Select Date"></app-datepicker>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 2">
                <div class="row justify-content-left">
                    <div class="col-12">
                        <mdb-form-control class="form-fill">
                            <mdb-select formControlName="weekDay" class="mdb-select">
                              <mdb-option *ngFor="let day of dayList"  [value]="day.value">{{
                                day.label
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select Day</label>
                        </mdb-form-control>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 3">
                <div class="row justify-content-left">
                    <div class="col-12">
                        <app-datepicker formControlName="dateOfMonth" label="Select Date"></app-datepicker>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 4">
                <div class="row justify-content-left">
                    <div class="col-12">
                        <mdb-form-control class="form-fill">
                            <mdb-select formControlName="hinduDatePaksha" class="mdb-select">
                              <mdb-option *ngFor="let paksha of pakshaList"  [value]="paksha.value">{{
                                paksha.label
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select paksha</label>
                        </mdb-form-control>
                    </div>
                </div>
                <div class="row justify-content-left">
                    <div class="col-12">
                        <mdb-form-control class="form-fill">
                            <mdb-select formControlName="hinduDateTithi" class="mdb-select">
                              <mdb-option *ngFor="let tithi of tithiList"  [value]="tithi.value">{{
                                tithi.label
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select tithi</label>
                        </mdb-form-control>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 5">
                <div class="row justify-content-left">
                    <div class="col-12">
                        <mdb-form-control class="form-fill">
                            <mdb-select formControlName="hinduDateTithi" class="mdb-select">
                              <mdb-option *ngFor="let tithi of tithiList"  [value]="tithi.value">{{
                                tithi.label
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select tithi</label>
                        </mdb-form-control>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="formGroupPresetOption.value.recurrence === 6">
                <div class="row justify-content-left">
                    <div class="col-12">
                    <app-datepicker-chips formControlName="pujaMultiDates" class='datepicker-chips'></app-datepicker-chips>
                    <span class="form-fill-error error-chips"  *ngIf="formGroupPresetOption.controls.pujaMultiDates.touched && formGroupPresetOption.controls.pujaMultiDates.invalid">Please add Dates</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="row">
        <div class="col-12" *ngIf="formGroupPresetOption.controls.offeredFor.value">
            <app-mdb-switch label="Week" formControlName="offeredForWeekCheckbox"></app-mdb-switch>
            <div style="padding-left: 44px;" *ngIf="formGroupPresetOption.value.offeredForWeekCheckbox">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="offeredForWeekInput" [isCurrencyMask]="true" data-panel="general" label='Amount'>
                        <input  #inputNameC currencyMask formControlName="offeredForWeekInput"   class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="divider"></div>

            <app-mdb-switch label="Month" formControlName="offeredForMonthCheckbox"></app-mdb-switch>
            <div style="padding-left: 44px;" *ngIf="formGroupPresetOption.value.offeredForMonthCheckbox">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="offeredForMonthInput" [isCurrencyMask]="true" data-panel="general" label='Amount'>
                        <input  #inputNameC currencyMask formControlName="offeredForMonthInput"   class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="divider"></div>
            <app-mdb-switch label="6 Month" formControlName="offeredForHalfYearCheckbox"></app-mdb-switch>
            <div style="padding-left: 44px;" *ngIf="formGroupPresetOption.value.offeredForHalfYearCheckbox">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="offeredForHalfYearInput" [isCurrencyMask]="true" data-panel="general" label='Amount'>
                        <input  #inputNameC currencyMask formControlName="offeredForHalfYearInput"   class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="divider"></div>
            <app-mdb-switch label="Year" formControlName="offeredForYearCheckbox"></app-mdb-switch>
            <div style="padding-left: 44px;" *ngIf="formGroupPresetOption.value.offeredForYearCheckbox">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="offeredForYearInput" [isCurrencyMask]="true" data-panel="general" label='Amount'>
                        <input  #inputNameC currencyMask formControlName="offeredForYearInput"   class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
            <div class="divider"></div>
        </div>
    </div>
</ng-container>